import { Component, Input, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { ModalService } from 'src/app/@shared/services/modal/modal.service';
import {
  CROWDEDNESS_HEAVY,
  CROWDEDNESS_LIGHT,
  CROWDEDNESS_MEDIUM,
  CROWDEDNESS_UNKNOWN,
  RESERVE_IS_POSSIBLE,
  SPECIAL_DATA_TEXTS,
  specialMessagesButtonAriaLabel,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { RouteSpecialData } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/route-special-data.interface';
import { specialMessagesContainer } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/special-messages/special-messages-container.interface';

@Component({
    selector: 'app-result-list-item-special-data',
    templateUrl: './result-list-item-special-data.component.html',
    styleUrls: ['./result-list-item-special-data.component.scss'],
    standalone: false
})
export class ResultListItemSpecialDataComponent implements OnInit {
  @Input() specialData: RouteSpecialData;
  @Input() specialMessages: specialMessagesContainer;
  @Input() agencyId: number;
  @Input() crowdednessIconName: string | null; // Add this input

  showSpecialMessagesButton: boolean
  specialMessagesCounter: number

  accessibleText: string
  accessibleWithOrderText: string
  flexibleText: string
  specialMessagesText: string
  specialMessagesAriaLabel: string
  reserveInAdvancedText: string

  accessibleTooltipText: string
  accessibleWithOrderTooltipText: string
  flexibleTooltipText: string

  crowdednessAlt: string

  get crowdednessIconSrc(): string {
    return `/assets/icons/${this.crowdednessIconName}.svg`;
  }

  constructor(
    private readonly modalService: ModalService,
    private readonly languageService: LanguageService
  ) { }

  ngOnInit(): void {
    const map = new Map();
    if(!this.specialMessages.stopMessages) {
      this.specialMessages.stopMessages = []
    }
    if(!this.specialMessages.routeMessages) {
      this.specialMessages.routeMessages = []
    }
    [...this.specialMessages.routeMessages, ...this.specialMessages.stopMessages].forEach(item => {
      map.set(item.messageId, item);
  });
    const messages = Array.from(map.values())
    // const routeMessagesCount = this.specialMessages.routeMessages?.length || 0;
    // const stopMessagesCount = this.specialMessages.stopMessages?.length || 0;

    this.specialMessagesCounter = messages.length;
    this.showSpecialMessagesButton = this.specialMessagesCounter > 0;

    this.initializeMultiLanguageTexts()
  }

  openSpecialMessages() {
    const messages = [...this.specialMessages.routeMessages, ...this.specialMessages.stopMessages]
    this.modalService.openSpecialMessagesModal(messages)
  }

  openFlexibleModal(isOrder: boolean) {
    if (this.agencyId) {
      this.modalService.openAgencyContactInfoModal(this.agencyId, isOrder);
    }
  }

  openAccissibleModal() {
    if (this.agencyId) {
      this.modalService.openAgencyContactInfoModal(this.agencyId, this.specialData.isCallNeeded ? true : false);
    }
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.accessibleText = SPECIAL_DATA_TEXTS.accessible[language.language]
      this.accessibleWithOrderText = SPECIAL_DATA_TEXTS.accessibleWithOrder[language.language]
      this.flexibleText = SPECIAL_DATA_TEXTS.flexible[language.language]
      this.specialMessagesText = SPECIAL_DATA_TEXTS.specialMessges[language.language]
      this.specialMessagesAriaLabel = specialMessagesButtonAriaLabel(
        language.language,
        this.specialMessagesText,
        this.specialMessagesCounter
      )
      this.reserveInAdvancedText = RESERVE_IS_POSSIBLE[language.language]
      this.flexibleTooltipText = SPECIAL_DATA_TEXTS.flexibleTooltip[language.language]
      this.accessibleTooltipText = SPECIAL_DATA_TEXTS.accessibleTooltip[language.language]
      this.accessibleWithOrderTooltipText = SPECIAL_DATA_TEXTS.accessibleWithOrderTooltip[language.language]
      this.crowdednessAlt = this.resolveCrowdednessAlt(language.language)
    })
  }

  private resolveCrowdednessAlt(language: string): string {
    switch (this.crowdednessIconName) {
      case 'crowdedness-light':
        return CROWDEDNESS_LIGHT[language];
      case 'crowdedness-medium':
        return CROWDEDNESS_MEDIUM[language];
      case 'crowdedness-heavy':
        return CROWDEDNESS_HEAVY[language];
      default:
        return CROWDEDNESS_UNKNOWN[language];
    }
  }
}
